<form (ngSubmit)="next()" [formGroup]="billingAddressForm">
  @if (!user?.defaultBillingAddress?.line1) {
    <div class="form-group col-sm-12 pl-0 billing-address">
      <div class="form-check ">
        <app-custom-icons [type]="iconTypes.ICON_COPY"></app-custom-icons>
        <a class="copy-shipment-address">{{
          'paymentForm.sameAsShippingAddress' | cxTranslate
          }}
          <input type="checkbox" name="sameAsShippingAddress" formControlName="sameAsShippingAddress"
            class="position-absolute w-100 h-100 m-0 same-address" [checked]="sameAsShippingAddress"
            (change)="toggleSameAsShippingAddress()" />
        </a>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-md-12">
      <div class="col-md-12 row p-0 m-0">
        <div class="form-group col-md-6 p-0">
          <label>
            <span class="label-content required mandatory">
              @if (isProfessionalCheckout()) {
                {{'addressForm.socialName.label' | cxTranslate}}
              } @else {
                {{'addressForm.firstName.label' | cxTranslate}}
              }
            </span>
            <input class="form-control" type="text" (focusin)="!(user?.commercialName) ? changeAetValidators() : null"
              formControlName="firstName" [readOnly]="user?.commercialName"
              [tabIndex]="(user?.commercialName) ? -1 : 0" />
            <cx-form-errors [control]="billingAddressForm.get('firstName')"></cx-form-errors>
          </label>
        </div>
        <div class="form-group col-md-6 pr-0 hidden-mobile">
          <label>
            <span [class]="!getBilling ? 'label-content' : 'label-content  required mandatory'">{{
              'addressForm.dni' | cxTranslate
            }}</span>
            <input type="text" class="form-control" formControlName="documentIdentifier"
              (focusin)="!(user?.documentIdentifier || !getBilling) ? changeAetValidators() : null"
              [readOnly]="user?.documentIdentifier || !getBilling"
              [tabIndex]="(user?.documentIdentifier || !getBilling) ? -1 : 0" />
            @if (getBilling) {
              <cx-form-errors [control]="billingAddressForm.get('documentIdentifier')"></cx-form-errors>
            }
          </label>
        </div>
      </div>

      <div class="form-group">
        <label>
          <span class="label-content required mandatory">
            @if (isProfessionalCheckout()) {
              {{'updateProfileForm.line1Prof.label' | cxTranslate}}
            } @else {
              {{'addressForm.address1' | cxTranslate}}
            }

          </span>
          <input type="text" maxlength="70" class="form-control" formControlName="line1" />
          <cx-form-errors [control]="billingAddressForm.get('line1')"></cx-form-errors>
        </label>
      </div>
      <div class="col-md-12 row p-0 m-0">
        <div class="col-md-6 p-0">
          <div class="form-group">
            <label>
              <span class="label-content required mandatory">{{
                'addressForm.email.label' | cxTranslate
              }}</span>
              <input type="email" class="form-control" formControlName="email"
                [readOnly]="user?.displayUid || guestEmail" [tabIndex]="(user?.displayUid || guestEmail) ? -1 : 0" />
            </label>
          </div>
        </div>
        <div class="col-md-6 pr-0">
          <div class="form-group">
            <label>
              <span class="label-content required mandatory">{{
                'addressForm.phoneNumber.label' | cxTranslate
              }}</span>
              <input type="text" class="form-control" formControlName="phone" />
              <cx-form-errors [control]="billingAddressForm.get('phone')"></cx-form-errors>
            </label>
          </div>
        </div>

      </div>

      <div class="col-md-12 row p-0 m-0">
        <div class="form-group col-md-6 p-0">
          <label>
            <span class="label-content required mandatory">{{
              'addressForm.zipCode.label' | cxTranslate
            }}</span>
            <input type="text" class="form-control" formControlName="postalCode" (keypress)="validatePostalCode()"
              (focusout)="validatePostalCode()" />
            <cx-form-errors [control]="billingAddressForm.get('postalCode')"></cx-form-errors>
          </label>
        </div>

        <div class="form-group col-md-6 pr-0">
          <label>
            <span class="label-content required mandatory">{{
              'addressForm.city.label' | cxTranslate
            }}</span>
            <input type="text" class="form-control" formControlName="town" />
            <cx-form-errors [control]="billingAddressForm.get('town')"></cx-form-errors>
          </label>
        </div>
      </div>
      <div class="col-md-12 row p-0 m-0">
        <div class="form-group col-md-6 p-0" formGroupName="country">

          @if (countries$ | async; as countries) {
            @if (countries.length !== 0) {
              <div>
                <label aria-required="true">
                  <span class="label-content required">{{
                    'addressForm.country' | cxTranslate
                  }}</span>
                  <!--                <ng-select-->
                  <!--                  class="country-select" [readonly]="true"-->
                  <!--                  formControlName="isocode"-->
                  <!--                  [searchable]="true"-->
                  <!--                  [clearable]="false"-->
                  <!--                  [items]="countries"-->
                  <!--                  bindLabel="name"-->
                  <!--                  bindValue="isocode"-->
                  <!--                  (change)="countrySelected($event)"-->
                  <!--                >-->
                <!--                </ng-select>-->
                <select formControlName="isocode" class="form-control country-select" readonly="true"
                  [attr.disabled]="true">
                  <option selected value="">
                    {{ 'updateProfileForm.country.label' | cxTranslate }}
                  </option>
                  @for (country of countries; track country) {
                    <option class="option-select" [value]="country.isocode">
                      {{ country.name }}
                    </option>
                  }
                </select>
                <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
                <cx-form-errors [control]="billingAddressForm.get('country.isocode')"></cx-form-errors>
              </label>
            </div>
          }
        }
      </div>
      @if (regions$ | async; as regions) {
        <ng-container formGroupName="region">
          @if (regions.length !== 0) {
            <div class="form-group col-md-6 pr-0 region-select">
              <label aria-required mandatory="true">
                <span class="label-content required mandatory">{{
                  'addressForm.state' | cxTranslate
                }}</span>
                <!--                <ng-select-->
                <!--                  class="region-select"-->
                <!--                  formControlName="isocode"-->
                <!--                  [searchable]="true"-->
                <!--                  [clearable]="false"-->
                <!--                  [items]="regions"-->
                <!--                  (change)="validatePostalCode()"-->
                <!--                  bindLabel="{{ regions[0].name ? 'name' : 'isocode' }}"-->
                <!--                  bindValue="{{ regions[0].name ? 'isocode' : 'region' }}"-->
                <!--                >-->
              <!--                </ng-select>-->
              <select formControlName="isocode" class="form-control" (change)="validatePostalCode()">
                <option selected disabled value="">
                  {{ 'addressForm.state' | cxTranslate }}
                </option>
                @for (region of regions; track region) {
                  <option class="option-select" [value]="region.isocode">
                    {{ region.name }}
                  </option>
                }
              </select>
              <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
              <cx-form-errors [control]="billingAddressForm.get('region.isocode')"></cx-form-errors>
            </label>
          </div>
        }
      </ng-container>
    }
  </div>
</div>
</div>

<div class="form-group get-billing-address col-sm-12">
  @if (user?.documentIdentifier || user?.billing) {
    <span class="form-check-label font-weight-bold">
      {{ 'paymentForm.billingAddressChecked' | cxTranslate }}
    </span>
  } @else {
    <div class="form-check">
      <label class="checkbox">
        <input type="checkbox" class="form-check-input" [checked]="getBilling" formControlName="billing"
          (change)="toggleGetBillingAddress()" />
        <span class="form-check-label">
          {{ 'paymentForm.getBillingAddress' | cxTranslate }}
        </span>
      </label>
    </div>
  }
</div>

<div class="row">
  <div class="form-group col-md-12 hidden-desktop">
    <label>
      <span [class]="!getBilling ? 'label-content' : 'label-content  required mandatory'">
        {{'addressForm.dni' | cxTranslate}}
      </span>
      <input type="text" class="form-control" formControlName="documentIdentifier"
        (focusin)="!(user?.documentIdentifier || !getBilling) ? changeAetValidators() : null"
        [readOnly]="user?.documentIdentifier || !getBilling"
        [tabIndex]="(user?.documentIdentifier || !getBilling) ? -1 : 0" />
      @if (getBilling) {
        <cx-form-errors [control]="billingAddressForm.get('documentIdentifier')"></cx-form-errors>
      }
    </label>
  </div>
</div>

<div class="cx-checkout-btns row">
  <div class="col-sm-12 col-md-6">
    @if (paymentMethodsCount === 0) {
      <button class="btn btn-block btn-white" (click)="back()">
        {{ 'common.backDeliveryData' | cxTranslate }}
      </button>
    }
    @if (paymentMethodsCount > 0) {
      <button class="btn btn-block btn-white" (click)="close()">
        {{ 'paymentForm.changePayment' | cxTranslate }}
      </button>
    }
  </div>
  <div class="col-sm-12 col-md-6">
    <button class="btn btn-block btn-black" type="submit">
      {{ 'common.continue' | cxTranslate }}
    </button>
  </div>
</div>
</form>
